import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api, { unwrap } from '../utils/api';

export default function CreateCategory() {
  const nav = useNavigate();
  const [form, setForm] = useState({ name: '', friendlyUrlName: '', color: '#af40f7', backgroundColor: '#f9f5ff', orderIndex: 0, ocassion: false, parentCategoryId: '' });
  const [parents, setParents] = useState([]);

  useEffect(() => {
    api.get('/categories/GetCategoriesAndSubCategoriesSimple').then(r => setParents(unwrap(r) || []));
  }, []);

  function u(k, v) { setForm(f => ({ ...f, [k]: v })); }

  async function save() {
    const payload = { ...form, parentCategoryId: form.parentCategoryId || null };
    if (!payload.friendlyUrlName) payload.friendlyUrlName = form.name.toLowerCase().replace(/\s+/g, '-');
    await api.post('/categories/CreateCategory', payload);
    nav('/pages/categories');
  }

  return (
    <>
      <h1>Create Category</h1>
      <div className="card" style={{ maxWidth: 640 }}>
        <div className="prop"><label>Name</label><input value={form.name} onChange={e => u('name', e.target.value)} /></div>
        <div className="prop"><label>Slug</label><input value={form.friendlyUrlName} onChange={e => u('friendlyUrlName', e.target.value)} placeholder="auto from name" /></div>
        <div className="row">
          <div className="prop" style={{ flex: 1 }}><label>Color</label><input type="color" value={form.color} onChange={e => u('color', e.target.value)} /></div>
          <div className="prop" style={{ flex: 1 }}><label>Background</label><input type="color" value={form.backgroundColor} onChange={e => u('backgroundColor', e.target.value)} /></div>
        </div>
        <div className="prop"><label>Parent (optional)</label>
          <select value={form.parentCategoryId} onChange={e => u('parentCategoryId', e.target.value)}>
            <option value="">— Top-level —</option>
            {parents.map(c => <option key={c._id} value={c._id}>{c.name}</option>)}
          </select>
        </div>
        <div className="prop"><label>Order index</label><input type="number" value={form.orderIndex} onChange={e => u('orderIndex', Number(e.target.value))} /></div>
        <div className="prop"><label><input type="checkbox" checked={form.ocassion} onChange={e => u('ocassion', e.target.checked)} /> Occasion category</label></div>
        <button className="btn" onClick={save}>Create</button>
      </div>
    </>
  );
}
